import React, { createContext, useCallback, useState, useContext } from "react";
import api from "../services/api";

import { AxiosResponse } from "axios";
import { showToastr } from "../components/Toastr";
import { toast } from "react-toastify";

import { useHistory } from 'react-router-dom';


interface ChangePasswordParams {
  password: string;
}

interface ChangePasswordContextData {
  changePassword(credentials: ChangePasswordParams): Promise<void>;
  hasErrors: boolean;
  showLoader: boolean;
  success: boolean;
}

const ChangePasswordContext = createContext<ChangePasswordContextData>({} as ChangePasswordContextData);

const ChangePasswordProvider: React.FC = ({ children }) => {

  const history = useHistory();

  const [errors, setErrors] = useState(false);
  const [loader, setLoader] = useState(false);
  const [success, setSuccess] = useState(false);

  const changePassword = useCallback(async ({ password, token }) => {
    setLoader(true);
    setErrors(false);
    setSuccess(false);
      await api({
        method: "put",
        url: "user/resetPassword",
        data: {
          password,
        },
      }).then((response: AxiosResponse) => {
        setLoader(false);
        setSuccess(true);
        showToastr(
          'Parabéns! Sua senha foi alterada com sucesso!',
          'success',
          toast.POSITION.BOTTOM_RIGHT
        );
        history.push('/');
        console.log(response.data);
      }).catch((err) => {
        setLoader(false);
        setErrors(true);
        setSuccess(false);
        if(err.response.status === 401) {
          showToastr(
            'A redefinição da sua senha foi negada! Tente novamente', 
            'error',
            toast.POSITION.BOTTOM_RIGHT
          );
        }
      })
  }, []);


  return (
    <ChangePasswordContext.Provider value={{ hasErrors: errors, showLoader: loader, changePassword, success }}>
      {children}
    </ChangePasswordContext.Provider>
  );
};

function useChangePassword(): ChangePasswordContextData {
  const context = useContext(ChangePasswordContext);

  if (!context) {
    throw new Error("useChangePassword must be used within an ChangePasswordProvider");
  }

  return context;
}

export { ChangePasswordProvider, useChangePassword };
